export function initTawk() {
    const scriptTag = document.currentScript;
    const chatId = document.querySelector('meta[name="tawk-chat-id"]')?.getAttribute('content');

    if (!chatId) {
        console.warn('[Tawk] chat_id manquant');
        return;
    }

    // API globale Tawk (doit exister AVANT le chargement)
    window.Tawk_API = window.Tawk_API || {};

    let tawkLoaded = false;

    /* ------------------------------
    * UI hooks
    * ------------------------------ */
    Tawk_API.onChatMaximized = function () {
        document.body.classList.add('tawk-open');
        document.getElementById('da-chat-open')?.classList.add('is-active');
    };

    Tawk_API.onChatMinimized = function () {
        document.body.classList.remove('tawk-open');
        document.getElementById('da-chat-open')?.classList.remove('is-active');
    };

    Tawk_API.onChatEnded = function () {
        document.body.classList.remove('tawk-open');
        document.getElementById('da-chat-open')?.classList.remove('is-active');
    };

    /* ------------------------------
    * Load Tawk script
    * ------------------------------ */
    function loadTawk() {
        if (tawkLoaded) return;
        tawkLoaded = true;

        const s = document.createElement('script');
        s.src = `https://embed.tawk.to/64712c88ad80445890ef58a5/${chatId}`;
        s.async = true;
        s.charset = 'UTF-8';
        s.crossOrigin = 'anonymous';

        document.body.appendChild(s);
    }

    /* ------------------------------
    * Lazy loading triggers
    * ------------------------------ */
    // Timeout de sécurité
    setTimeout(loadTawk, 5000);

    // Interactions utilisateur
    ['click', 'scroll', 'keydown', 'mousemove', 'touchstart'].forEach((evt) => {
        window.addEventListener(evt, loadTawk, {
        once: true,
        passive: true,
        });
    });

    // Bouton custom
    document.getElementById('da-chat-open')?.addEventListener('click', () => {
        loadTawk();
        window.Tawk_API?.toggle?.();
    });
}
